import { NEKOSEI_GAME_FULL_NAME } from "@/domains/nekosei/NekoseiGameName";

/**
 * サイト全体で使用する定数定義
 */

// ベースURL
export const SITE_BASE_URL = "https://nekometry.com";

// サイト基本情報
export const SITE_INFO = {
  name: "Nekometry",
  alternateName: "ネコメトリー",
  description: "猫の健康管理をサポートするWebサービス",
  language: "ja-JP",
} as const;

// 共通のパンくずリスト項目
export const COMMON_BREADCRUMB_ITEMS = {
  home: {
    name: "ホーム",
    url: `${SITE_BASE_URL}/`,
  },
  welcome: {
    name: "猫を迎える",
  },
  health: {
    name: "猫の健康を見守る",
  },
  game: {
    name: "ゲームで体験する",
  },
  meal: {
    name: "猫のごはんを考える",
  },
  media: {
    name: "猫の記事・動画を見る",
  },
  calorie: {
    name: "ごはん量を計算する",
    url: `${SITE_BASE_URL}/calorie/`,
  },
  foods: {
    name: "ごはんを探す",
    url: `${SITE_BASE_URL}/calorie/foods/`,
  },
  transition: {
    name: "新しいごはんへ切り替える",
    url: `${SITE_BASE_URL}/calorie/transition/`,
  },
  videos: {
    name: "おすすめ猫動画",
    url: `${SITE_BASE_URL}/videos/`,
  },
  learningVideos: {
    name: "学びの動画を見る",
    url: `${SITE_BASE_URL}/videos/?tag=learning`,
  },
  healingVideos: {
    name: "癒やしの動画を見る",
    url: `${SITE_BASE_URL}/videos/?tag=healing`,
  },
  pets: {
    name: "ペット一覧",
    url: `${SITE_BASE_URL}/pets/`,
  },
  age: {
    name: "年齢を人間に換算する",
    url: `${SITE_BASE_URL}/age/`,
  },
  mydata: {
    name: "マイデータ",
    url: `${SITE_BASE_URL}/me/`,
  },
  terms: {
    name: "利用規約",
    url: `${SITE_BASE_URL}/terms/`,
  },
  privacy: {
    name: "プライバシーポリシー",
    url: `${SITE_BASE_URL}/privacy/`,
  },
  cost: {
    name: "猫を迎える費用を知る",
    url: `${SITE_BASE_URL}/welcome-plan/`,
  },
  articles: {
    name: "記事を読む",
    url: `${SITE_BASE_URL}/articles/`,
  },
  adoption: {
    name: "保護猫と出会える場所を探す",
    url: `${SITE_BASE_URL}/adoption/`,
  },
  bodyCondition: {
    name: "体型をチェックする",
    url: `${SITE_BASE_URL}/body-condition/`,
  },
  foodsSafety: {
    name: "猫が食べても大丈夫か調べる",
    url: `${SITE_BASE_URL}/foods-safety/`,
  },
  events: {
    name: "猫のイベントを探す",
    url: `${SITE_BASE_URL}/events/`,
  },
  firstCatGame: {
    name: "はじめて猫を飼う暮らしを体験する",
    url: `${SITE_BASE_URL}/game/first-cat/`,
  },
  nekoseiGame: {
    name: NEKOSEI_GAME_FULL_NAME,
    url: `${SITE_BASE_URL}/game/nekosei/`,
  },
} as const;
